export default __webpack_public_path__ + "static/media/bg_music.62cd79a5.mp3";